<template>
  <div class="config_count">
    <el-form-item :label="$t('保留小数')">
      <el-input-number
        v-model="data.decimal"
        controls-position="right"
        :placeholder="$t('请输入')"
        :min="0"
      ></el-input-number>
    </el-form-item>
    <el-form-item :label="$t('千位分隔')">
      <el-switch
        v-model="data.thousandSeparator"
        @change="handleChangeTS"
      ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('大写金额')">
      <el-switch v-model="data.isChinese" @change="handleChangeCap"></el-switch>
    </el-form-item>
    <el-form-item :label="$t('是否可见')">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
    <el-divider>{{ $t("计算公式") }}</el-divider>
    <div class="mt-8">
      <el-button @click="handleCountSet" type="primary" size="mini">{{
        $t("计算公式设置")
      }}</el-button>
    </div>
    <!-- <el-divider>{{ $t("联动设置") }}</el-divider>
    <div class="mt-8">
      <el-button @click="handleLinkageSet" type="primary" size="mini">{{
        $t("联动设置")
      }}</el-button>
    </div> -->
    <l-dialog
      :title="$t('计算公式设置')"
      :visible.sync="formVisible"
      :height="720"
      :width="1000"
      @ok="handleSave"
      @open="handleOpen"
      @close="handleClose"
    >
      <div style="padding: 16px" class="box">
        <div class="layTop">
          <div class="l-rblock top_box">
            <div>
              <span
                ><span class="blod">{{ data.label }}=</span></span
              >
              <span class="clear_style1" @click="handleClear">清空</span>
              <span class="clear_style2" @click="handleCallBack">退格</span>
              <i
                class="el-icon-right clear_style2 margint_4"
                @click="handleRight"
              ></i>
              <i
                class="el-icon-back clear_style2 margint_4"
                @click="handleBack"
              ></i>
            </div>
            <div class="code_box">
              <span class="code_cursor" v-if="formatJson.cursor == 0"></span>
              <span v-for="(item, index) in formatCells" :key="index">
                <span class="fun_color" v-if="item.type == 'fun'">
                  {{ item.name.toUpperCase() }}
                </span>
                <span class="comp_color" v-if="item.type == 'comp'">
                  #{{ item.tableId ? handleGetLabel(item.tableId) : "主表" }}.{{
                    handleGetLabel(item.name)
                  }}#
                </span>
                <span class="num_color" v-if="item.type == 'num'">
                  {{ item.name }}
                </span>
                <span
                  class="code_cursor"
                  v-if="index + 1 == formatJson.cursor"
                ></span>
              </span>
            </div>
          </div>
        </div>
        <div class="center_box">
          <div
            v-for="(item, index) in numList"
            :key="index"
            class="border_color num_wh"
            @click="handleClick(item, 'num')"
          >
            {{ item.label }}
          </div>
        </div>
        <div class="layBottom">
          <div class="down_box">
            <div class="bottom_left">
              <p class="p1">主表组件</p>
              <div class="coms_box">
                <div
                  v-for="(item, index) in valueOptions.mainList"
                  :key="index"
                  class="border_color"
                  @click="handleClick(item, 'comp')"
                >
                  {{ item.label }}
                </div>
              </div>
              <p class="p1 margin_top0">子表组件</p>
              <div
                v-for="(item, index) in valueOptions.gridtableList"
                :key="index"
              >
                <p class="p3 margin_top0">{{ item.label }}</p>
                <div class="coms_box">
                  <div
                    v-for="(t, i) in item.coms"
                    :key="i"
                    class="border_color"
                    @click="handleClick(t, 'comp', item.value)"
                  >
                    {{ t.label }}
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom_right">
              <div class="right1">
                <p class="p1">插入函数</p>
                <p
                  class="p2"
                  v-for="item in funList"
                  :key="item.value"
                  @mouseover="handleMouseover(item.hopeList)"
                  @click="handleClick(item, 'fun')"
                >
                  {{ item.label }}
                </p>
              </div>
              <ul class="right2">
                <li v-for="(item, index) in hopeList" :key="index">
                  {{ item }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </l-dialog>
  </div>
</template>

<script>
export default {
  name: "config-count",
  props: ["data"],
  inject: ["formDesign"],
  data() {
    return {
      formVisible: false,
      funList: [
        {
          label: "ABS",
          value: "abs",
          hopeList: [
            "ABS函数可以获取一个数的绝对值",
            "用法：ABS(数字)",
            "示例：ABS(-8)可以返回8，也就是-8的绝对值",
          ],
        },
        {
          label: "AVERAGE",
          value: "average",
          hopeList: [
            "AVERAGE函数可以获取一组数值的算术平均值",
            "用法：AVERAGE(数字1,数字2,...)",
            "示例：AVERAGE({语文成绩},{数学成绩}, {英语成绩})返回三门课程的平均分",
          ],
        },
        {
          label: "CEILING",
          value: "ceiling",
          hopeList: [
            "CEILING函数可以将数字增大到最接近原值的指定因数的倍数",
            "用法：CEILING(数字,因数)",
            "示例：CEILING(7,6)返回12，因为12比7大的同时，也是6的倍数中最接近7的数字",
          ],
        },
        {
          label: "COUNT",
          value: "count",
          hopeList: [
            "COUNT函数可以获取参数的数量",
            "用法：COUNT(值,值,...)",
            "示例：COUNT(小明,小王,小张,小李)返回4，也就是人员的数量",
          ],
        },
        {
          label: "COUNTIF",
          value: "countif",
          hopeList: [
            "COUNTIF函数可以获取数组中满足条件的参数个数",
            "用法：COUNTIF(数组,'条件')",
            "示例：COUNTIF(子表单.性别, '女')，可得到子表单中性别填的是'女'的数据条数；COUNTIF([1,2,3,4],'>2')，可得到1,2,3,4中大于2的数字数量，结果为2。",
          ],
        },
        {
          label: "FIXED",
          value: "fixed",
          hopeList: [
            "FIXED函数可将数字舍入到指定的小数位数并输出为文本",
            "用法：FIXED(数字,小数位数)",
            "示例：FIXED(3.1415,2)返回'3.14'",
          ],
        },
        {
          label: "FLOOR",
          value: "floor",
          hopeList: [
            "FLOOR函数可将数字减小到最接近原值的指定因数的倍数",
            "用法：FLOOR(数字,因数)",
            "示例：FLOOR(7,6)返回6，因为6比7小的同时，也是6的倍数中最接近7的数字",
          ],
        },
        {
          label: "INT",
          value: "int",
          hopeList: [
            "INT函数可以获取一个数的整数部分",
            "用法：INT(数字)",
            "示例：INT(3.1415)返回3，也就是3.1415的整数部分",
          ],
        },
        {
          label: "LARGE",
          value: "large",
          hopeList: [
            "LARGE函数可以获取数据集中第k个最大值",
            "用法：LARGE(数组,k)",
            "示例：LARGE({学生成绩.数学成绩},1)返回子表单'学生成绩'中排名第1的'数学成绩'",
          ],
        },
        {
          label: "LOG",
          value: "log",
          hopeList: [
            "LOG函数可以根据指定底数返回数字的对数",
            "用法：LOG(数字,底数)",
            "示例：LOG(100,10)返回2，也就是以10为底数100的对数",
          ],
        },
        {
          label: "MAX",
          value: "max",
          hopeList: [
            "MAX函数可以获取一组数值的最大值",
            "用法：MAX(数字1,数字2,...)",
            "示例：MAX({语文成绩},{数学成绩},{英语成绩})返回三门课程中的最高分",
          ],
        },
        {
          label: "MIN",
          value: "min",
          hopeList: [
            "MIN函数可以获取一组数值的最小值",
            "用法：MIN(数字1,数字2,...)",
            "示例：MIN({语文成绩},{数学成绩},{英语成绩})返回三门课程中的最低分",
          ],
        },
        {
          label: "MOD",
          value: "mod",
          hopeList: [
            "MOD函数可以获取两数相除的余数",
            "用法：MOD(被除数,除数)",
            "示例：MOD(4,3)返回1，也就是4/3的余数",
          ],
        },
        {
          label: "POWER",
          value: "power",
          hopeList: [
            "POWER函数可以获取数字乘幂的结果",
            "用法：POWER(数字,指数)",
            "示例：POWER(3，2)返回9，也就是3的2次方",
          ],
        },
        {
          label: "PRODUCT",
          value: "product",
          hopeList: [
            "PRODUCT函数可以获取一组数值的乘积",
            "用法：PRODUCT(数字1,数字2,...)",
            "示例：PRODUCT({单价}, {数量})获取总价，也就是单价和数量的乘积",
          ],
        },
        {
          label: "RAND",
          value: "rand",
          hopeList: [
            "RAND函数可返回大于等于0且小于1的均匀分布随机实数",
            "用法：RAND()",
            "示例：RAND()返回0.424656",
          ],
        },
        {
          label: "ROUND",
          value: "round",
          hopeList: [
            "ROUND函数可以将数字四舍五入到指定的位数",
            "用法：ROUND(数字,数字位数)",
            "示例：ROUND(3.1485,2)返回3.15",
          ],
        },
        {
          label: "SMALL",
          value: "small",
          hopeList: [
            "SMALL函数可以返回数据集中第k个最小值",
            "用法：SMALL(数组,k)",
            "示例：SMALL({学生成绩.数学成绩}, 1)返回子表单'学生成绩'中排名倒数第一的'数学成绩'",
          ],
        },
        {
          label: "SQRT",
          value: "sqrt",
          hopeList: [
            "SQRT函数可以获取一个数字的正平方根",
            "用法：SQRT(数字)",
            "示例：SQRT(9)返回3，也就是9的正平方根",
          ],
        },
        {
          label: "SUM",
          value: "sum",
          hopeList: [
            "SUM函数可以获取一组数值的总和",
            "用法：SUM(数字1,数字2,...)",
            "示例：SUM({语文成绩},{数学成绩}, {英语成绩})返回三门课程的总分",
          ],
        },
        {
          label: "SUMPRODUCT",
          value: "sumproduct",
          hopeList: [
            "SUMPRODUCT函数可以将数组间对应的元素相乘，并返回乘积之和，适用于加权求和",
            "用法：SUMPRODUCT(数组,数组...)",
            "示例：SUMPRODUCT([1,2,3],[0.1,0.2,0.3])返回1.4，也就是 1×0.1 + 2×0.2 + 3×0.3的值",
          ],
        },
      ],
      hopeList: [],
      numList: [
        { label: 1, value: 1 },
        { label: 2, value: 2 },
        { label: 3, value: 3 },
        { label: 4, value: 4 },
        { label: 5, value: 5 },
        { label: 6, value: 6 },
        { label: 7, value: 7 },
        { label: 8, value: 8 },
        { label: 9, value: 9 },
        { label: 0, value: 0 },
        { label: "+", value: "+" },
        { label: "-", value: "-" },
        { label: "*", value: "*" },
        { label: "/", value: "/" },
        { label: ">", value: ">" },
        { label: "<", value: "<" },
        { label: "=", value: "=" },
        { label: "(", value: "(" },
        { label: ")", value: ")" },
        { label: "[", value: "[" },
        { label: "]", value: "]" },
        { label: "'", value: "'" },
        { label: `"`, value: `"` },
        { label: ",", value: "," },
        { label: ".", value: "." },
      ],
      formatJson: {
        cells: [], // 括号，公式，组件，子组件(),
        cursor: 0,
      },
    };
  },
  computed: {
    formatCells() {
      return this.formatJson.cells;
    },
    valueOptions() {
      const res = {
        mainList: [],
        gridtableList: [],
      };
      const formInfo = this.formDesign.toSaveData();
      formInfo.tabList.forEach((tab) => {
        tab.components.forEach((com) => {
          if (
            ![
              "viewtable",
              "card",
              "btn",
              "tab",
              "collapse",
              "divider",
              "gridtable",
              "btn",
              "qrcode",
              "barcode",
              "tableLayout",
              "time",
              "timerange",
              "datetime",
              "datetimerange",
              "areaselect",
              "layerbmap",
              "upload",
              "uploadimg",
              "guid",
              "companySelect",
              "departmentSelect",
              "userSelect",
              "company",
              "department",
              "modifytime",
              "modifyuser",
              "createtime",
              "createuser",
              "icon",
              "switch",
              "color",
            ].includes(com.type) &&
            com.prop != this.data.prop
          ) {
            res.mainList.push({ value: com.prop, label: com.label });
          } else if (["gridtable"].includes(com.type)) {
            let comsList = [];
            com.children.forEach((c) => {
              if (
                c.prop != this.data.prop &&
                ![
                  "time",
                  "timerange",
                  "datetime",
                  "datetimerange",
                  "areaselect",
                  "layerbmap",
                  "upload",
                  "uploadimg",
                  "guid",
                  "companySelect",
                  "departmentSelect",
                  "userSelect",
                  "company",
                  "department",
                  "modifytime",
                  "modifyuser",
                  "createtime",
                  "createuser",
                  "icon",
                  "switch",
                  "color",
                ].includes(c.type)
              ) {
                comsList.push({ value: c.prop, label: c.label });
              }
            });
            res.gridtableList.push({
              value: com.prop,
              label: com.label,
              coms: comsList,
            });
          }
        });
      });
      return res;
    },
    allComps() {
      let res = [];
      res = this.$deepClone(this.valueOptions.mainList);
      this.valueOptions.gridtableList.map((item) => {
        res.push({ value: item.value, label: item.label });
        res.push(...item.coms);
      });
      return res;
    },
  },
  methods: {
    handleCountSet() {
      this.formVisible = true;
    },
    handleLinkageSet() {},
    handleSave() {
      this.data.formatJson = this.formatCells;
      this.formVisible = false;
    },
    handleOpen() {
      if (this.data.formatJson.length)
        this.formatJson.cells = this.$deepClone(this.data.formatJson);
      this.formatJson.cursor = this.formatJson.cells.length;
    },
    handleClose() {
      this.handleClear();
      this.formVisible = false;
    },
    handleMouseover(val) {
      this.hopeList = val;
    },
    handleClick(item, type, value) {
      let cell = {
        name: item.value,
        type,
      };
      if (value) cell.tableId = value;
      this.formatCells.splice(this.formatJson.cursor, 0, cell);
      this.formatJson.cursor += 1;
      if (type === "fun") {
        let leftBracket = {
          name: "(",
          type,
        };
        let rightBracket = {
          name: ")",
          type,
        };
        this.formatCells.splice(
          this.formatJson.cursor,
          0,
          leftBracket,
          rightBracket
        );
        this.formatJson.cursor += 1;
      }
    },
    handleGetLabel(prop) {
      let list = this.allComps.filter((item) => item.value == prop);
      return list[0].label;
    },
    handleBack() {
      if (this.formatJson.cursor) {
        this.formatJson.cursor -= 1;
      }
    },
    handleRight() {
      if (this.formatJson.cursor < this.formatCells.length) {
        this.formatJson.cursor += 1;
      }
    },
    handleCallBack() {
      if (this.formatJson.cursor > 0) {
        this.formatCells.splice(this.formatJson.cursor - 1, 1);
        this.formatJson.cursor -= 1;
      }
    },
    handleClear() {
      this.formatJson = {
        cells: [],
        cursor: 0,
      };
    },
    handleChangeTS(val) {
      if (val) this.$set(this.data, "isChinese", false);
    },
    handleChangeCap(val) {
      if (val) this.$set(this.data, "thousandSeparator", false);
    },
  },
};
</script>

<style lang="less">
.box {
  user-select: none;
}
.layTop {
  height: 150px;
  position: relative;
  z-index: 1;
}
.down_box {
  padding: 0 16px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  > div {
    width: 49%;
    height: 100%;
    border: 1px solid #dddddd;
    border-radius: 2px 2px 2px 2px;
  }
  .coms_box {
    width: 100%;
    overflow: hidden;
    padding-left: 16px;
  }
  .bottom_left {
    overflow: auto;
  }
  .bottom_right {
    display: flex;
    color: #333333;
    .right1 {
      width: 40%;
      overflow: auto;
    }
    .right2 {
      width: 60%;
      padding: 11px 16px 16px 24px;
      overflow: auto;
      li {
        margin-bottom: 10px;
        font-weight: 400;
      }
    }
  }
  .p1 {
    font-weight: bold;
    font-size: 14px;
    margin: 16px;
  }
  .p2 {
    height: 32px;
    line-height: 32px;
    padding-left: 16px;
    cursor: pointer;
  }
  .p2:hover {
    background: rgba(94, 149, 255, 0.1);
    color: #5e95ff;
  }
  .p3 {
    color: #333333;
    margin: 16px;
  }
  .margin_top0 {
    margin-top: 0;
  }
}
.border_color {
  float: left;
  padding: 7px 8px;
  margin-right: 8px;
  border-radius: 4px;
  border: 1px solid #dddddd;
  font-weight: 400;
  color: #666666;
  margin-bottom: 16px;
  cursor: pointer;
}
.border_color:hover {
  background: rgba(94, 149, 255, 0.1);
  border-color: #5e95ff;
  color: #5e95ff;
}
.num_wh {
  width: 40px;
  height: 32px;
  padding: 0;
  line-height: 32px;
  text-align: center;
  color: #333333;
}
.center_box {
  width: 100%;
  overflow: hidden;
  padding-top: 16px;
  position: relative;
  z-index: 1;
}
.layBottom {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  padding-top: 278px;
  width: 100%;
  padding-bottom: 56px;
}
.top_box {
  background: #f6f8fa;
  border-radius: 4px;
  border: 1px solid #dddddd;
  padding: 16px;
  .span_block {
    padding: 6px 12px;
    background: #fff9d1;
    color: #ff0101;
  }
  .blod {
    font-weight: bold;
    color: #333333;
  }
  .clear_style1 {
    float: right;
    color: #ff8080;
    font-weight: bold;
    cursor: pointer;
  }
  .clear_style2 {
    float: right;
    color: #5e95ff;
    margin-right: 16px;
    font-weight: bold;
    cursor: pointer;
  }
  .code_box {
    margin-top: 16px;
    height: 75px;
    overflow: auto;
  }
  .fun_color {
    color: #d81f1f;
  }
  .num_color {
    color: #333333;
  }
  .comp_color {
    color: #5e95ff;
  }
  .code_cursor {
    display: inline-block;
    width: 1px;
    height: 16px;
    line-height: 20px;
    background: #000;
    animation: mymove 1s infinite;
    margin-bottom: -2px;
  }
  @keyframes mymove {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }
  .margint_4 {
    margin-top: 4px;
  }
}
</style>